/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface JobEmployerSummary {
  id: string;
  name: string;
  cover_url?: string | null;
}
